import { Link } from "react-router-dom";
import style from "./Footer.module.scss";
import { useTranslation } from "../../shared/hooks/useTranslation";

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className={style.footer}>
      <div className={style.footerInner}>
        <div className={style.footerBrand}>
          <div className={style.footerLogoWrap}>
            <img src="/logo.svg" alt="UMC" className={style.footerLogo} />
          </div>
          <div className={style.footerBrandText}>
            <span className={style.footerBrandTop}>{t.footerBrandTop}</span>
            <span className={style.footerBrandMain}>{t.footerBrandMain}</span>
            <span className={style.footerBrandSub}>{t.footerBrandSub}</span>
          </div>
        </div>

        <div className={style.footerCol}>
          <p className={style.footerColTitle}>{t.footerClinic}</p>
          <div className={style.footerLinks}>
            <a href="https://umc.org.kz/" target="_blank" rel="noopener noreferrer">{t.footerClinicSite}</a>
            <a href="https://umc.org.kz/about-umc/" target="_blank" rel="noopener noreferrer">{t.footerClinicAbout}</a>
            <a href="https://umc.org.kz/specialists/" target="_blank" rel="noopener noreferrer">{t.footerClinicSpecialists}</a>
          </div>
        </div>

        <div className={style.footerCol}>
          <p className={style.footerColTitle}>{t.footerPatients}</p>
          <div className={style.footerLinks}>
            <a href="https://umc.org.kz/pricelist/" target="_blank" rel="noopener noreferrer">{t.footerPatientsServices}</a>
            <a href="https://umc.org.kz/patient-reminder/?affiliate=gospitalization" target="_blank" rel="noopener noreferrer">{t.footerPatientsHospitalization}</a>
            <a href="https://umc.org.kz/patient-reminder/" target="_blank" rel="noopener noreferrer">{t.footerPatientsReminder}</a>
          </div>
        </div>

        <div className={style.footerCol}>
          <p className={style.footerColTitle}>{t.footerContacts}</p>
          <div className={style.footerLinks}>
            <a href="https://umc.org.kz/contacts/" target="_blank" rel="noopener noreferrer">{t.footerContactsReach}</a>
            <a href="https://umc.org.kz/" target="_blank" rel="noopener noreferrer">{t.footerContactsBooking}</a>
            <Link to="/policy">{t.footerPolicy}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
